import { useSyncExternalStore } from "react";
import {
  getEntryTiming,
  subscribeEntryTiming,
  type EntryTiming,
} from "@/engine/diagnostics/entryTiming";

/** The React seam onto the entry-timing store. */
export function useEntryTiming(): EntryTiming | null {
  return useSyncExternalStore(subscribeEntryTiming, getEntryTiming, () => null);
}
